import { Button } from "react-bootstrap";

export default function UpdateOpenModal({ openModal }) {
  return (
    <Button
      className="btn btn-link"
      style={{ fontWeight: "normal", padding: 0 }}
      onClick={openModal}
    >
      Rediger
    </Button>
  );
}
